module.exports = __webpack_public_path__ + "static/media/icon_teeth_circle.65158c29.svg";